import { render, staticRenderFns } from "./Participant.vue?vue&type=template&id=180dbf39&scoped=true&"
import script from "./Participant.vue?vue&type=script&lang=js&"
export * from "./Participant.vue?vue&type=script&lang=js&"
import style0 from "./Participant.vue?vue&type=style&index=0&id=180dbf39&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180dbf39",
  null
  
)

export default component.exports